import styled from 'styled-components';
import { useState } from 'react';

import { breakpoints } from 'styles/theme/breakpoints';
import { ConditionalWrapper } from 'shared/components/ConditionalWrapper';
import { Image } from 'shared/components/Image';
import { ZoomedInDraggableRobotWrapper } from 'productTemplate/components/robotGallery/ZoomedInDraggableRobotWrapper';

interface IRobotImageExpandedView {
  alt: string;
  handleOnClick?: () => void;
  isZoomedIn?: boolean;
  url: string;
}

export const RobotImageExpandedView = ({
  alt,
  handleOnClick,
  url,
  isZoomedIn,
}: IRobotImageExpandedView) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleImageClick = () => {
    if (handleOnClick && !isDragging) {
      handleOnClick();
    }
  };

  return (
    <ConditionalWrapper
      if={isZoomedIn}
      with={(_children) => (
        <ZoomedInDraggableRobotWrapper setIsDragging={setIsDragging}>
          {_children}
        </ZoomedInDraggableRobotWrapper>
      )}
    >
      <RobotImageExpandedView.Image
        $isZoomedIn={isZoomedIn}
        crop
        alt={alt}
        disableLazyLoad
        draggable="false"
        onClick={handleImageClick}
        sizes={`(max-width: ${breakpoints.medium}px) 350px, (max-width: ${breakpoints.mediumLarge}px) 450px, 500px`}
        src={url || ''}
      />
    </ConditionalWrapper>
  );
};

RobotImageExpandedView.Image = styled(Image)<{
  $isZoomedIn: boolean;
}>`
  cursor: pointer;

  ${({ $isZoomedIn, theme }) =>
    $isZoomedIn &&
    `
      transform: scale(2);
      z-index: ${theme.zIndex.zoomedInRobot};
      cursor: grab;
      width: max-content;
      max-width: 100% !important;

      &:active {
        cursor: grabbing;
      }
  `}
`;
